import React, { FC } from 'react'

import { DemoPopup } from 'pages/soundscape-page/components/DemoPopup'

import bg from './assets/safe-bg.jpg'
import mobileBg from './assets/safe-bg-mobile.jpg'

import type { SoundscapeDemoPopupContent } from 'redux/popupReducer'

interface SoundscapeSafeProps {
  content: SoundscapeDemoPopupContent
}

export const SoundscapeSafe: FC<SoundscapeSafeProps> = ({ content }) => {
  return (
    <DemoPopup
      backgroundImage={bg}
      mobileBackgroundImage={mobileBg}
      logo={content.logoUrl}
      title={content.title}
      description={content.description}
    />
  )
}
